import { Box, createStyles, Transition } from '@mantine/core';
import { getDefaultZIndex, rem } from '@mantine/styles';
import { IconButton } from '@repo/foundations';

const popIn = {
	in: { opacity: 1, transform: 'scale(1)' },
	out: { opacity: 0, transform: `scale(.9) translateY(${rem(28)})` }, // 28px is the height of the button
	transitionProperty: 'transform, opacity',
	common: { transformOrigin: 'center center' },
};

const useStyles = createStyles((theme) => ({
	buttonWrapper: {
		display: 'flex',
		position: 'absolute',
		width: '100%',
		top: `calc(-${theme.spacing['2xl']} - ${theme.spacing.xs} - ${theme.spacing['4xs']})`,
		left: '50%',
		transform: 'translateX(-50%)',
		justifyContent: 'center',
		alignItems: 'center',
		overflow: 'hidden',
		paddingTop: theme.spacing['4xs'],
		paddingBottom: theme.spacing.xs,
	},
	button: {
		zIndex: getDefaultZIndex('max'),
		borderRadius: '50%',
		boxShadow: theme.shadows.md,
		backgroundColor: theme.other.getColor('surface/primary/default'),

		'&:hover': {
			backgroundColor: theme.other.getColor('surface/primary/hover'),
		},
		'&:active': {
			backgroundColor: theme.other.getColor('surface/primary/active'),
		},
		pointerEvents: 'auto',
	},
}));

export function ScrollDownButton({
	shouldShow,
	onClick,
}: {
	shouldShow: boolean;
	onClick: () => void;
}) {
	const { classes } = useStyles();

	return (
		<Transition mounted={shouldShow} transition={popIn} duration={200}>
			{(styles) => (
				<Box
					className={classes.buttonWrapper}
					style={{ pointerEvents: 'none' }}
				>
					<IconButton
						data-testid="scroll-down-button"
						className={classes.button}
						iconName="chevronDown"
						size="lg"
						onClick={onClick}
						style={styles}
					/>
				</Box>
			)}
		</Transition>
	);
}
